<template>
  <div class="calico-result">
    <CalicoIAReply :message="message" />
  </div>
</template>
  
  <script>
  import CalicoIAReply from '@/components/calico/aiReply/index.vue';
  
  export default {
    name: 'CalicoResult',
    components: {
      CalicoIAReply,
    },
    props: {
      message: {
        type: String,
        required: true
      },
      content: {
        type: String,
        required: true
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .calico-result {
    @include stack-space($space-large);
    align-items: flex-start;
    width: 100%;
  }
  </style>